import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../../../../context/ConfigContext';
import MyprofileIcon from "../../../../images/MyProfile.svg";
import MesCommandesIcon from "../../../../images/mes-commandes.svg";
import { UserInfo } from '../../../../interfaces/user';
import { getIcon, IconType } from '../../../../theme/icons';
import './UserMenu.scss';
import { useDispatch } from 'react-redux';
import { clearStoreItem, logout } from '../../../../store/actions/actions';
import { clearCart } from '../../../../store/cart/cartActions';

interface UserMenuProps {
  userInfo: UserInfo;
  onLogout?: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({ userInfo, onLogout }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { config } = useConfig();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleProfileClick = () => {
    setShowUserMenu(!showUserMenu);
  };

  const handleMenuItemClick = (path: string) => {
    navigate(path);
    setShowUserMenu(false);
  };

  const handleLogoutClick = () => {
    localStorage.removeItem("accessToken");
    dispatch(clearStoreItem("auth3dthird"));
    dispatch(clearStoreItem("authGoogleSuccess"));
    dispatch(clearStoreItem("authAppleSuccess"));
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
    }

    dispatch(clearCart());
    dispatch(logout())

    navigate("/");
    setShowUserMenu(false);
  };

  return (
    <div className="user-menu-container">
      {/* User Profile Button */}
      <button
        className="auth-profile-btn"
        onClick={handleProfileClick}
      >
        {getIcon(IconType.USER, {
          color: config?.primaryColor,
          onClick: handleProfileClick,
        })}
      </button>

      {/* User Menu Dropdown */}
      {showUserMenu && (
        <div className="auth-dropdown">
          <div className="auth-dropdown-content">
            <div className="auth-dropdown-header">
              <div className="user-info">
                <div className="user-avatar-large">
                  <span className="user-initial-large">
                    {userInfo?.firstName?.charAt(0)?.toUpperCase() || 'U'}
                  </span>
                </div>
                <div className="user-details">
                  <div className="user-name">{userInfo?.firstName} {userInfo?.lastName}</div>
                  <div className="user-email">{userInfo?.email || userInfo?.phoneNumber}</div>
                </div>
              </div>
            </div>

            <div className="auth-dropdown-divider" />

            <button
              className="auth-dropdown-item"
              onClick={() => handleMenuItemClick('/mon-profile')}
            >
              <img src={MyprofileIcon} alt="" />
              Mon Profil
            </button>

            <button
              className="auth-dropdown-item"
              onClick={() => handleMenuItemClick('/mes-commandes')}
            >
              <img src={MesCommandesIcon} alt="" />
              Mes Commandes
            </button>

            <div className="auth-dropdown-divider" />

            <button
              className="auth-dropdown-item logout-item"
              onClick={handleLogoutClick}
            >
              Se déconnecter
            </button>
          </div>
        </div>
      )}

      {/* Overlay to close dropdown when clicking outside */}
      {showUserMenu && (
        <div
          className="auth-dropdown-overlay"
          onClick={() => setShowUserMenu(false)}
        />
      )}
    </div>
  );
};

export default UserMenu;